import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  View,
  Keyboard,
  TouchableWithoutFeedback,
  TouchableOpacity,
  Text,
  StyleSheet,
} from 'react-native'
import { Picker } from '@react-native-picker/picker'

export default class SelectProvider extends Component {
  static childContextTypes = {
    openSelect: PropTypes.func,
    cancelSelect: PropTypes.func,
  }

  state = {
    open: false,
    options: [],
    value: null,
  }

  getChildContext = () => ({
    openSelect: this.openSelect,
    cancelSelect: this.handleCancel,
  })

  openSelect = (options, value, callback, cancelCallback) => {
    this._callback = callback
    this._cancelCallback = cancelCallback
    Keyboard.dismiss()

    this.setState({
      open: true,
      options,
      value,
    })
  }

  handleCancel = () => {
    if (this._cancelCallback) {
      this._cancelCallback()
    }

    this._callback = null
    this._cancelCallback = null

    this.setState({
      open: false,
    })
  }

  handleSelect = () => {
    const { value } = this.state

    if (this._callback) {
      this._callback(value)
    }

    this._callback = null
    this._cancelCallback = null

    this.setState({
      open: false,
    })
  }

  handleChange = value => {
    this.setState({ value })
  }

  renderMenu() {
    const { options, value } = this.state

    return (
      <View style={styles.menuWrapper}>
        <TouchableWithoutFeedback onPressIn={this.handleCancel}>
          <View style={styles.backdrop} />
        </TouchableWithoutFeedback>
        <View style={styles.selectWrapper}>
          <View style={styles.buttonRow}>
            <TouchableOpacity onPress={this.handleCancel}>
              <Text style={[styles.button, styles.cancelButton]}>Cancel</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={this.handleSelect}>
              <Text style={[styles.button, styles.okButton]}>OK</Text>
            </TouchableOpacity>
          </View>
          <Picker selectedValue={value} onValueChange={this.handleChange}>
            {options.map(opt => (
              <Picker.Item
                label={opt.label}
                key={opt.value}
                value={opt.value}
              />
            ))}
          </Picker>
        </View>
      </View>
    )
  }

  render() {
    const { children } = this.props
    const { open } = this.state

    return (
      <View style={styles.main}>
        {children}
        {open ? this.renderMenu() : null}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
  },
  menuWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  buttonRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
  },
  selectWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: '#fff',
  },
  button: {
    fontSize: 15,
  },
  okButton: {
    fontWeight: '600',
    color: '#07f',
  },
  cancelButton: {
    color: '#999',
  },
})
